import React from "react"

export default ({ title }) => (
  <div className="flex items-center">+&nbsp;{title}</div>
)
